import React, { useEffect } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Button, Container } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { closeModal } from "../modals/modalReducer";

export default function ErrorModal({ verb = "submitting", action, redirect }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { responsive } = useSelector((state) => state.app);

  useEffect(() => {
    if (redirect) {
      history.push(redirect);
    }
  }, [history, redirect]);

  function handleCloseModal() {
    dispatch(closeModal());
  }

  return (
    <ModalWrapper
      size="tiny"
      style={{ width: !responsive.isMobile ? 450 : "98%" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
      closeCrossColour={"blue"}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      isClose={false}
    >
      <div className="post-action-modal">
        <Container textAlign="center">
          <div>
            <div
              className="modal-blue-text error"
              style={{ fontSize: 20, color: "#db2828" }}
            >
              Something went wrong
            </div>
            <div className="modal-blue-text">
              An error occurred when {verb} your {action}. Our team has been
              notified and will investigate the problem.
            </div>
            <div className="modal-blue-text">
              We will contact you by email when the issue has been resolved.
            </div>
          </div>
        </Container>
        <Button
          className="overwrite-button cta-orange block-button"
          content={"Close"}
          onClick={handleCloseModal}
        />
      </div>
    </ModalWrapper>
  );
}
